import React from 'react';
import Box from '@mui/material/Box'

import Button from './Button';

import { useDataProviderActions } from '../../providers/DataProvider';

export default function FormFooter({ onNext, onPrev, hideBackButton, nextButtonDisabled, prevButtonDisabled, nextButtonLabel }) {

    const { prevStep } = useDataProviderActions();
    const handlePrev = onPrev || prevStep;

    const justifyContent = hideBackButton ? 'center' : 'space-between';

    return (
        <Box sx={{ display: 'flex', justifyContent, padding: '30px 0' }}>
            {!hideBackButton ? (
                <Button
                    variant="contained"
                    sx={{ mt: 3, ml: 1 }}
                    disabled={prevButtonDisabled}
                    onClick={handlePrev}>
                    &lt;&lt; volver
                </Button>) : null}
            <Button
                disabled={nextButtonDisabled}
                onClick={onNext}>
                {nextButtonLabel || 'siguiente >>'}
            </Button>
        </Box>
    );

}
